import classNames from 'classnames';
import { spinnerStyle } from './spinner.linaria';
function Spinner({ className }) {
    return <div className={classNames([spinnerStyle, className])}/>;
}
Spinner.defaultProps = {
    className: null,
};
export default Spinner;
